import * as React from 'react';
import {useEnvironmentContext} from 'src/hooks/useEnvironmentContext';
import {AuthFlow} from 'src/components/authentication/auth-flow';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  TitleMedium,
  SubTitleMedium,
  BodyMedium,
  BodyLargeBold,
  BodyMediumBold,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  RadioGroup,
  RadioButton,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';
import classify from 'src/utils/classify';
import css from './authenticator-and-sms-register.css';


type Props = {
  goToPage: (page: string, newMfaFlow?: string | null | undefined) => void;
};

const AuthenticatorAndSmsRegister = ({goToPage}: Props) => {
  const {t} = useLabelTranslation();
  const {isExtension} = useEnvironmentContext();
  const [authType, setAuthType] = React.useState('SMS');

  const handleContinueClick = async () => {
    if (authType === 'SMS') {
      goToPage(
        AuthFlow.SMS_REGISTRATION.PHONE_REGISTRATION,
        'SMS_REGISTRATION',
      );
    } else {
      goToPage(AuthFlow.TOTP.TOTP_REGISTRATION, 'TOTP');
    }
  };
  return (
    <div className={classify(css.container, {[css.containerExt]: isExtension})}>
      {isExtension ? (
        <SubTitleMedium className={css.title}>
          {t('Select_authentication_method', 'Select authentication method')}
        </SubTitleMedium>
      ) : (
        <TitleMedium className={css.title}>
          {t('Select_authentication_method', 'Select authentication method')}
        </TitleMedium>
      )}
      <RadioGroup
        align="vertical"
        name="auth-type"
        value={authType}
        onChange={setAuthType}
        classNames={{wrapper: css.radioGroup}}
      >
        <RadioButton
          value="SMS"
          classNames={{
            wrapper: classify(css.radioButton, {
              [css.radioButtonExt]: isExtension,
              [css.radioButtonSelected]: authType === 'SMS',
            }),
            label: css.radioLabel,
          }}
        >
          {isExtension ? (
            <BodyMediumBold>{t('Text_Message', 'Text Message')}</BodyMediumBold>
          ) : (
            <>
              <BodyLargeBold className={css.stepText}>
                {t('Text_Message', 'Text Message')}
              </BodyLargeBold>
              <BodyMedium color="secondary">
                {t(
                  'Get_the_verification_code_sent_to_your_phone',
                  'Get the verification code sent to your phone',
                )}
              </BodyMedium>
            </>
          )}
        </RadioButton>
        <RadioButton
          value="TOTP"
          classNames={{
            wrapper: classify(css.radioButton, {
              [css.radioButtonExt]: isExtension,
              [css.radioButtonSelected]: authType === 'TOTP',
            }),
            label: css.radioLabel,
            radio: classify({[css.radio]: !isExtension}),
          }}
        >
          {isExtension ? (
            <BodyMediumBold>
              {t('Authenticator_App', 'Authenticator App')}
            </BodyMediumBold>
          ) : (
            <>
              <BodyLargeBold className={css.stepText}>
                {t('Authenticator_App', 'Authenticator App')}
              </BodyLargeBold>

              <BodyMedium color="secondary">
                {t(
                  'Enter_the_6digit_code_from_your_authenticator_app',
                  'Enter the 6-digit code from your authenticator app',
                )}
              </BodyMedium>
            </>
          )}
        </RadioButton>
      </RadioGroup>
      <Button
        onClick={handleContinueClick}
        size={isExtension ? 'small' : 'medium'}
        type="primary"
      >
        {t('Continue', 'Continue')}
      </Button>
    </div>
  );
};

export default AuthenticatorAndSmsRegister;
